import { useState } from 'react';
import type { JSX } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { SeedData } from '@/data/reports/seedData';
import { useDataProvider } from '@/data/provider';
import { toast } from '@/lib/toast';
import { DataRecoveryAlert } from './DataRecoveryAlert';

type DataRecoveryAlertConnectedProps = {
  title: string;
  error: unknown;
};

export function DataRecoveryAlertConnected({
  title,
  error,
}: DataRecoveryAlertConnectedProps): JSX.Element {
  const queryClient = useQueryClient();
  const { settings } = useDataProvider();
  const [isSeeding, setIsSeeding] = useState(false);
  const [isClearing, setIsClearing] = useState(false);

  const handleSeedReset = async () => {
    setIsSeeding(true);
    try {
      await SeedData.clearAndSeed();
      toast.success("Dati di esempio rigenerati. Ricarico l'app...");
      window.setTimeout(() => {
        window.location.reload();
      }, 200);
    } catch (err) {
      console.error('Seed reset failed:', err);
      toast.error('Errore durante la rigenerazione dei dati.');
    } finally {
      setIsSeeding(false);
    }
  };

  const handleClearAllData = async () => {
    setIsClearing(true);
    try {
      await settings.clearAllData();
      await queryClient.invalidateQueries();
      toast.success("Dati eliminati. Ricarico l'app...");
      window.setTimeout(() => {
        window.location.reload();
      }, 200);
    } catch (err) {
      console.error('Clear data failed:', err);
      toast.error("Errore durante l'eliminazione dei dati.");
    } finally {
      setIsClearing(false);
    }
  };

  return (
    <DataRecoveryAlert
      title={title}
      error={error}
      onSeedReset={handleSeedReset}
      onClearAllData={handleClearAllData}
      isSeeding={isSeeding}
      isClearing={isClearing}
    />
  );
}
